<div
  class="agents-page"
  [ngClass]="{
    'agents-dark': _isDarkTheme,
    'agents-light': _isLightTheme,
    'agents-paper': _isPaperTheme,
  }"
>
  <!-- Left: Agents list -->
  <aside class="agents-sidebar">
    <ddc-agents-list
      [agents]="_agents"
      [selectedAgentId]="_selectedAgent?.id"
      [theme]="_theme"
      (agentSelected)="onAgentSelected($event)"
    ></ddc-agents-list>
  </aside>

  <!-- Right: Agent detail -->
  <main class="agents-main" *ngIf="_selectedAgent; else noAgent">
    <!-- Agent Header -->
    <header class="agent-header">
      <div class="agent-header-avatar" [ngClass]="'status-' + _selectedAgent.status">
        <mat-icon>{{ _selectedAgent.avatarIcon }}</mat-icon>
      </div>
      <div class="agent-header-info">
        <h1 class="agent-name">{{ _selectedAgent.name }}</h1>
        <p class="agent-description">{{ _selectedAgent.description }}</p>
      </div>
      <div class="agent-header-status">
        <span class="status-badge" [ngClass]="'status-' + _selectedAgent.status">
          @switch (_selectedAgent.status) {
            @case ('working') {
              <mat-icon class="spin">autorenew</mat-icon>
              Working
            }
            @case ('succeeded') {
              <mat-icon>check_circle</mat-icon>
              Ready
            }
            @case ('error') {
              <mat-icon>error</mat-icon>
              Error
            }
            @default {
              <mat-icon>pause_circle</mat-icon>
              Idle
            }
          }
        </span>
        <span class="status-message" *ngIf="_selectedAgent.statusMessage">
          {{ _selectedAgent.statusMessage }}
        </span>
      </div>
    </header>

    <!-- Course dashboard (calendar, stats, progress) -->
    <ddc-agent-course
      *ngIf="_selectedAgent.course"
      [course]="_selectedAgent.course"
      [theme]="_theme"
    ></ddc-agent-course>

    <div class="no-course-banner" *ngIf="!_selectedAgent.course">
      <mat-icon>info</mat-icon>
      <span>No course created yet for this agent.</span>
    </div>

    <!-- Created content placeholders -->
    <ddc-agent-content [contents]="_selectedAgent.createdContents" [theme]="_theme"></ddc-agent-content>

    <!-- Chat with agent -->
    <ddc-agent-chat [agent]="_selectedAgent" [theme]="_theme"></ddc-agent-chat>
  </main>

  <ng-template #noAgent>
    <main class="agents-main agents-empty">
      <mat-icon class="empty-icon">smart_toy</mat-icon>
      <h2>No agent selected</h2>
      <p>Select a teacher agent from the list, or create a new one.</p>
    </main>
  </ng-template>
</div>
